import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

import {
    REINITIALIZE,
    DOB_SET_VALUE,
    DOB_SET_VALID,
    GENDER_SET_VALUE,
    GENDER_SET_VALID,
    FIRST_NAME_SET_VALUE,
    FIRST_NAME_SET_VALID,
    LAST_NAME_SET_VALUE,
    LAST_NAME_SET_VALID,
    PHONE_NUMBER_SET_VALUE,
    PHONE_NUMBER_SET_VALID,
    EMAIL_SET_VALUE,
    EMAIL_SET_VALID,
    NATIONALITY_SET_VALUE,
    NATIONALITY_SET_VALID,
    OCCUPATION_SET_VALUE,
    OCCUPATION_SET_VALID,
    ID_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALID,
    ID_TYPE_SET_VALUE,
    ID_TYPE_SET_VALID,
    FORM_VALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM,
    FORM_INVALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM,
    COLLECT_PERSONAL_DETAILS_FORM_DATA,
    API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM,
    API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM,
    API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM,
    SUBMIT_PERSONAL_DETAILS_SUCCESS,
    SUBMIT_PERSONAL_DETAILS_FAILURE,
    API_PENDING_TRANSITION_NATIONALITIES,
    API_SUCCESS_TRANSITION_NATIONALITIES,
    API_FAILURE_TRANSITION_NATIONALITIES,
    SET_NATIONALITIES_VALUE,
    SALUTATION_SET_VALUE,
    SALUTATION_SET_VALID,
    SELECTED_FORM_SET_VALUE,
    CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS,
    PASSPORT_SET_VALID,
    PASSPORT_SET_VALUE,
    TRIGGER_GET_NIDA,
    NIDA_SET_VALUE,
    API_PENDING_TRANSITION_NIDA,
    API_SUCCESS_TRANSITION_NIDA,
    API_FAILURE_TRANSITION_NIDA,
    CELL_SET_VALUE,
    SECTOR_SET_VALUE,
    DISTRICT_SET_VALUE,
    VILLAGE_SET_VALUE,
    DISTRICT_SET_VALID,
    SECTOR_SET_VALID,
    CELL_SET_VALID,
    VILLAGE_SET_VALID,
    API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM,
} from '../../actions/motorPrivateRW/personalDetails';

export const initPersonal = {
    formStatus: FORM_STATUS.INVALID,
    dropOffDetails: null,
    personalDetailsReferenceData: null,
    nationalities: null,
    natiolalityApiCallStatus: null,
    apiCallStatus: null,
    selectedForm: 'personalDetails',
    nidaDetails: null,
    nidaStatus: null,
    blacklisted: {
        value: null,
        error: null,
        status: null,
    },
    form: {
        gender: { value: null, error: null, status: null },
        firstName: { value: null, error: null, status: null },
        lastName: { value: null, error: null, status: null },
        dob: { value: null, error: null, status: null },
        nationality: { value: null, error: null, status: null },
        occupation: { value: null, error: null, status: null },
        idNumber: { value: null, error: null, status: null },
        passport: { value: null, error: null, status: null },
        idType: { value: null, error: null, status: null },
        phoneNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        salutation: { value: null, error: null, status: null },
        district: { value: null, error: null, status: null },
        sector: { value: null, error: null, status: null },
        cell: { value: null, error: null, status: null },
        village: { value: null, error: null, status: null },
    },
};

export default (state = initPersonal, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_MOTOR_INSURANCE_PERSONAL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case API_PENDING_TRANSITION_NATIONALITIES:
            return { ...state, natiolalityApiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_TRANSITION_NATIONALITIES:
            return { ...state, natiolalityApiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_TRANSITION_NATIONALITIES:
            return { ...state, natiolalityApiCallStatus: API_CALL_STATUS.FAILURE };

        case SET_NATIONALITIES_VALUE:
            return { ...state, nationalities: action.value };

        case DOB_SET_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));

        case DOB_SET_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case LAST_NAME_SET_VALUE:
            return updateFormField('lastName', (field) => ({
                ...field,
                value: action.value,
            }));
        case LAST_NAME_SET_VALID:
            return updateFormField('lastName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case GENDER_SET_VALUE:
            return updateFormField('gender', (field) => ({ ...field, value: action.value }));

        case GENDER_SET_VALID:
            return updateFormField('gender', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case FIRST_NAME_SET_VALUE:
            return updateFormField('firstName', (field) => ({
                ...field,
                value: action.value,
            }));

        case FIRST_NAME_SET_VALID:
            return updateFormField('firstName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PHONE_NUMBER_SET_VALUE:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case PHONE_NUMBER_SET_VALID:
            return updateFormField('phoneNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case EMAIL_SET_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));

        case EMAIL_SET_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case NATIONALITY_SET_VALUE:
            return updateFormField('nationality', (field) => ({
                ...field,
                value: action.value,
            }));

        case NATIONALITY_SET_VALID:
            return updateFormField('nationality', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case OCCUPATION_SET_VALUE:
            return updateFormField('occupation', (field) => ({
                ...field,
                value: action.value,
            }));

        case OCCUPATION_SET_VALID:
            return updateFormField('occupation', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_NUMBER_SET_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_NUMBER_SET_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PASSPORT_SET_VALUE:
            return updateFormField('passport', (field) => ({
                ...field,
                value: action.value,
            }));

        case PASSPORT_SET_VALID:
            return updateFormField('passport', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_TYPE_SET_VALUE:
            return updateFormField('idType', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_TYPE_SET_VALID:
            return updateFormField('idType', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SALUTATION_SET_VALUE:
            return updateFormField('salutation', (field) => ({ ...field, value: action.value }));

        case SALUTATION_SET_VALID:
            return updateFormField('salutation', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DISTRICT_SET_VALUE:
            return updateFormField('district', (field) => ({
                ...field,
                value: action.value,
            }));
        case SECTOR_SET_VALUE:
            return updateFormField('sector', (field) => ({
                ...field,
                value: action.value,
            }));
        case CELL_SET_VALUE:
            return updateFormField('cell', (field) => ({
                ...field,
                value: action.value,
            }));
        case VILLAGE_SET_VALUE:
            return updateFormField('village', (field) => ({
                ...field,
                value: action.value,
            }));

        case DISTRICT_SET_VALID:
            return updateFormField('district', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case SECTOR_SET_VALID:
            return updateFormField('sector', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case CELL_SET_VALID:
            return updateFormField('cell', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case VILLAGE_SET_VALID:
            return updateFormField('village', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case CALCULATE_PERSONAL_DETAILS_AML_WHITELIST_SUCCESS:
            return {
                ...state,
                blacklisted: {
                    ...state.blacklisted,
                    value: action.value,
                    status: API_CALL_STATUS.SUCCESS,
                },
            };

        case NIDA_SET_VALUE:
            return {
                ...state,
                nidaDetails: action.value,
            };

        case SELECTED_FORM_SET_VALUE:
            return { ...state, selectedForm: action.value };

        //    API Calls
        case API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };
        case API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: null };

        case API_PENDING_TRANSITION_NIDA:
            return { ...state, nidaStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_NIDA:
            return { ...state, nidaStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_NIDA:
            return { ...state, nidaStatus: API_CALL_STATUS.FAILURE };

        // Submit user data
        case COLLECT_PERSONAL_DETAILS_FORM_DATA:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case SUBMIT_PERSONAL_DETAILS_SUCCESS:
            return { ...state, personalDetailsReferenceData: action.value };
        case SUBMIT_PERSONAL_DETAILS_FAILURE:
            return { ...state, personalDetailsReferenceData: action.error };

        // Reset the state
        case REINITIALIZE:
            return initPersonal;
        default:
            return state;
    }
};
